// @ts-nocheck
export const CLIENT_EMAIL = {
  estimate: "estimate",
  depositInvoice: "depositInvoice",
  invoice: "invoice",
};

export const CLIENT_EMAIL_LABEL = {
  [CLIENT_EMAIL.estimate]: "Estimate",
  [CLIENT_EMAIL.depositInvoice]: "Deposit Invoice",
  [CLIENT_EMAIL.invoice]: "Invoice",
};